import type { ViewMode } from '../../@types/wishlist.js';

const VIEW_MODE_KEY = 'ents-wishlist-model-view';
const CURATED_LIST_VIEW_MODE_KEY = 'ents-wishlist-view-mode-curated';

export function loadCuratedListViewMode(): ViewMode {
  const raw = globalThis.localStorage.getItem(CURATED_LIST_VIEW_MODE_KEY);
  if (raw === 'product' || raw === 'model' || raw === 'vto') return raw;
  return 'product';
}

export function saveCuratedListViewMode(view: ViewMode): void {
  globalThis.localStorage.setItem(CURATED_LIST_VIEW_MODE_KEY, view);
}

export function loadViewMode(): ViewMode {
  return globalThis.localStorage.getItem(VIEW_MODE_KEY) === 'true' ? 'model' : 'product';
}

export function saveViewMode(view: ViewMode): void {
  globalThis.localStorage.setItem(VIEW_MODE_KEY, String(view === 'model'));
}
